export default __webpack_public_path__ + "264247fbaf1983431ab40d4a9981f927.svg";